export default __webpack_public_path__ + "static/media/banner7.8a8d4c5a.jpg";